<template>
  <div class="form-container elevation-1">
    <v-form ref="form">
      <h2 class="display-3">Sign in</h2>
      <div class="form-region">
        <v-text-field type="text" label="Email address" v-model="form.email" name="email" hint="Enter your email address." 
          autocapitalize="off" :rules=[rules.required] :validate-on-blur=true></v-text-field>
        <v-text-field type="password" label="Password" v-model="form.password" name="password" hint="Enter your password." 
          :rules=[rules.required] :validate-on-blur=true v-on:keyup.enter="login()"></v-text-field>
      </div>
      <div class="link-group">
        <router-link to="/user/reset-password" class="text-center">Forgot your password?</router-link>
      </div>
      <v-layout justify-end>
        <v-btn dark @click="login()" color="#e7511e" >sign in</v-btn>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import CommonRules from 'src/common-rules.js';
import Authentication from '@/services/AuthenticationApi';
// import axios from 'axios';
export default {
  components: {
  },
  created: () => {
    document.title = 'ThinkSpatial | Sign In';
  },
  data() {
    return {
      error: null,
      form: {
        email: null,
        password: null,
        remember: false,
      },
      rules: CommonRules,
    }
  },
  methods: {
    async login () {
      try {
        if (this.$refs.form.validate()) {
          const response = await Authentication.login({
            email: this.form.email,
            password: this.form.password
          })          
          this.$store.dispatch('setToken', response.data.token)
          this.$store.dispatch('setUser', response.data.user)
          if(response.data.user.xeroAccessToken === '') {
            window.location.href = response.data.user.xeroConsent;
          } else {
            this.$router.push({ name: 'dashboard'})
          }
        }
      } catch (err) {
        if(err.response) {
          this.$swal({
            title: 'Oops!',
            text: err.response.data.error,
            type: 'error'
          })
          .then(()=>{
            if(err.response.data.error.indexOf("Reset") >= 0) {
              this.$router.push({
                name: 'forgotpassword'
              })
            }
          });
        } else {
          // eslint-disable-next-line
          console.log(err)
        }
      }
    }
  },  
  mounted() {
    if (this.error) {
      this.$swal({
        title: 'Oops!',
        text: this.error,
        type: 'error'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'assets/landing.scss';
</style>
